import { Container, MantineSpacing, Stack, StyleProp } from '@mantine/core';

import { SectionTitle } from 'components';
import classes from './index.module.css';

interface ISection {
  center?: boolean;
  children: any;
  footer?: boolean;
  gap?: number;
  hero?: boolean;
  id?: string;
  maw?: number;
  pt?: StyleProp<MantineSpacing>;
  title?: string;
  titleVariant?: string;
}

const Section = ({
  id,
  center,
  children,
  gap = 42,
  hero,
  footer,
  maw,
  pt,
  title,
  titleVariant,
}: ISection) => {
  return (
    <Container id={id} className={`${classes.section} ${hero ? classes.hero : ''} ${footer ? classes.footer : ''}`} pt={pt}>
      <Stack gap={gap} align={center ? 'center' : undefined} justify={center ? 'center' : undefined} maw={maw}>
        {title && <SectionTitle title={title} variant={titleVariant} center={true} />}
        {children}
      </Stack>
    </Container>
  );
}

export default Section;